module.exports = __webpack_public_path__ + "img/mazda6-20.e232eaa8.jpg";